import AbdulSamad from "../Assets/Images/1.png";
import MsharyAlAfasy from "../Assets/Images/2.png";
import AhmedAlAjamy from "../Assets/Images/3.png";
import MohamedAlMinshawi from "../Assets/Images/4.png";
import HaniAlRifai from "../Assets/Images/5.png";
import AsserAlQatami from "../Assets/Images/6.png";
import YasserAlDossari from "../Assets/Images/7.png";
const MainReader = [
  {
    identifier: "ar.abdulbasitmujawwad",
    name: "عبدالباسط عبدالصمد",
    englishName: "Abdul Basit Abdul Samad",
    photo: AbdulSamad,
  },

  {
    identifier: "ar.alafasy",
    name: "مشاري العفاسي",
    englishName: "Mishari Al-afasi",
    photo: MsharyAlAfasy,
  },
  {
    identifier: "ar.ahmedalajmi",
    name: "أحمد العجمي",
    englishName: "Ahmed Al-Agamy",
    photo: AhmedAlAjamy,
  },
  {
    identifier: "ar.muhammadsiddiqalminshawimujawwad",
    name: "محمد المنشاوي",
    englishName: "Muhammad Al-Minshawi",
    photo: MohamedAlMinshawi,
  },
  {
    identifier: "ar.haniarrifai",
    name: "هاني الرفاعي",
    englishName: "Hani Al-Rifai",
    photo: HaniAlRifai,
  },
  {
    identifier: "ar.nasseralqatami",
    name: "ناصر القطامي",
    englishName: "Naser Al-Katamy",
    photo: AsserAlQatami,
  },
  {
    identifier: "ar.yasseraldossari",
    name: "ياسر الدوسري",
    englishName: "Yasser Al-Dosary",
    photo: YasserAlDossari,
  },
];
export default MainReader;
